import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const DoxExplorerFilesTableUploaderCell = ({ width, uploaderIsBlock, targetName, uploaderName, justifyContent }) => {
    const [uploaderValue, setUploaderValue] = useState(null)

    useEffect(() => {
        if (uploaderIsBlock && uploaderName !== uploaderValue) {
            setUploaderValue(uploaderName)
        } else if (!uploaderIsBlock && uploaderValue !== targetName) {
            setUploaderValue(targetName)
        }
    }, [uploaderIsBlock, targetName, uploaderName, uploaderValue, setUploaderValue])

    return (
        <div className={classnames('doxe-files-table-cell hrb-column uploader', `hrb-is-${width}`)}
            style={{ justifyContent: justifyContent }}>
            <span>{uploaderValue || '-'} </span>
        </div>
    )
}

DoxExplorerFilesTableUploaderCell.propTypes = {    
    uploaderIsBlock: PropTypes.bool,
    width: PropTypes.number.isRequired,
    justifyContent: PropTypes.string
}   

export default DoxExplorerFilesTableUploaderCell;